<template >
  <div class="GuestInfo" v-if="show" :class="{ loading: loading > 0 }">
    <h2 class="title">{{ tran("CONFIRM_PAYMENT_TITLE") }}</h2>
    <div class="guest-info">
      <div class="guests payment-section">
        <div
          class="payment-methods"
          v-if="paymentMethods && paymentMethods.length > 1"
        >
          <h4><span v-html="tran('SELECT_PAYMENT_METHODS')"></span></h4>
          <div
            v-for="(item, index) in paymentMethods"
            :key="index"
            class="payment-method pointer"
            :class="{ selected: paymentMethodCode == item.code }"
            @click.prevent="paymentMethodCode = item.code"
          >
            <span v-html="item.title"></span>
          </div>
          <div v-if="currentMethod.creditCard" class="">
            <h4><span v-html="tran('PAYMENT_INFORMATION')"></span></h4>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group floating-label">
                  <input
                    id="cardNumber"
                    class="form-control"
                    type="text"
                    :placeholder="tran('CARD_NUMBER')"
                    v-model="cardInfo.number"
                  />
                  <label for="cardNumber"
                    ><span v-text="tran('CARD_NUMBER')"></span
                  ></label>
                  <span
                    class="error"
                    v-if="errors['cardNumber']"
                    v-text="errors['cardNumber']"
                  ></span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group floating-label">
                  <label><span v-text="tran('CARD_TYPE')"></span></label>
                  <div class="birthday">
                    <vSelect
                      :options="cardTypes"
                      :clearable="false"
                      :reduce="(item) => item.value"
                      class=""
                      :placeholder="tran('CARD_TYPE')"
                      label="title"
                      v-model="cardInfo.type"
                    >
                    </vSelect>
                  </div>
                  <span
                    class="error"
                    v-if="errors['cardType']"
                    v-text="errors['cardType']"
                  ></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group floating-label">
                  <input
                    id="cardExpiry"
                    class="form-control"
                    type="text"
                    :placeholder="tran('CARD_EXPIRY')"
                    v-model="cardInfo.expiry"
                    @input="handleInputExpiry"
                  />
                  <label for="cardExpiry"
                    ><span v-text="tran('CARD_EXPIRY')"></span
                  ></label>
                  <span
                    class="error"
                    v-if="errors['cardExpiry']"
                    v-text="errors['cardExpiry']"
                  ></span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group floating-label">
                  <input
                    id="cardCvv"
                    class="form-control"
                    type="text"
                    :placeholder="tran('CARD_CVV')"
                    v-model="cardInfo.cvv"
                  />
                  <label for="cardCvv"
                    ><span v-text="tran('CARD_CVV')"></span
                  ></label>
                  <span
                    class="error"
                    v-if="errors['cardCvv']"
                    v-text="errors['cardCvv']"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons">
            <button
              v-if="currentMethod.redirect"
              type="button"
              class="btn btn-success"
              @click.prevent="pay(currentMethod)"
            >
              {{ tran("CONTINUE") }}
            </button>
            <button
              v-else-if="currentMethod.creditCard"
              type="button"
              class="btn btn-success"
              @click.prevent="pay(currentMethod)"
            >
              {{ tran("CONFIRM_PAYMENT") }}
            </button>
          </div>
        </div>
      </div>
      <div class="rooms" v-if="summaries && summaries.items.length">
        <div
          class="room item"
          v-for="(item, index) in summaries.items"
          :key="index"
          :class="{ hideSummary: !rooms[index] || rooms[index].hideSummary }"
        >
          <div class="wrapper">
            <div class="image">
              <img v-if="item.image" :src="item.image" />
              <div class="info">
                <h4 class="title" v-html="item.title"></h4>
                <div class="location" v-html="item.location"></div>
              </div>
            </div>
            <div class="desc" v-html="item.detail"></div>
            <div class="buttons">
              <a
                v-if="!rooms[index] || rooms[index].hideSummary"
                @click.prevent="hideSummary(index)"
                class="pointer"
                ><span v-html="tran('VIEW_VACATION_SUMMARY')"></span
              ></a>
              <a v-else @click.prevent="hideSummary(index)" class="pointer"
                ><span v-html="tran('HIDE_VACATION_SUMMARY')"></span
              ></a>
            </div>
          </div>
        </div>
        <div
          class="trip-totals"
          v-if="userRooms.length > 1"
          v-html="summaries.summaries"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "ConfirmPayment",
  components: { vSelect },
  props: {
    run: Function,
  },
  data: function () {
    return {
      loading: 0,
      items: false,
      rooms: { 0: { hideSummary: false } },
      paymentMethodCode: "aeon",
      cardInfo: {},
      errors: {},
      cardTypes: [
        { value: "visa", title: this.tran("CARD_VISA") },
        { value: "mastercard", title: this.tran("CARD_MASTERCARD") },
        { value: "upi", title: this.tran("CARD_UPI") },
        { value: "jcb", title: this.tran("CARD_JCB") },
      ],
    };
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "review_pay");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
    "cardInfo.number": function (v) {
      if (!v || v.length < 8) {
        return;
      }
      const type = this.getCardType(v);
      if (type) {
        for (const cardType of this.cardTypes) {
          if (cardType.value == type) {
            this.cardInfo.type = type;
          }
        }
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    userRooms() {
      return this.run("get", "rooms");
    },
    summaries() {
      return this.run("get", "summaries");
    },
    paymentMethods() {
      return this.run("get", "paymentMethods");
    },
    currentMethod() {
      if(!this.paymentMethods){
        return {};
      }
      for (const paymentMethod of this.paymentMethods) {
        if (paymentMethod.code == this.paymentMethodCode) {
          return paymentMethod;
        }
      }
      return {};
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {
      // this.fetch();
    },
    onHide: function () {},
    // async fetch() {
    //   this.loading++;
    //   const rooms = this.run("rooms");
    //   const numberOfRoom = this.run("numberOfRoom");
    //   const promotionCode = this.run("promotionCode");
    //   const res = await this.run(
    //     "fetch",
    //     "index.php?option=com_cruise&task="+(this.run('get', 'config.task', "booking"))+".getPaymentMethods",
    //     { rooms, numberOfRoom, promotionCode }
    //   );
    //   if (!res.success) {
    //     this.run("showMessage", res.message ?? "error");
    //     this.loading--;
    //     return;
    //   }
    //   this.items = res.data;

    //   this.loading--;
    // },
    getCardType(cc) {
      let amex = new RegExp("^3[47][0-9]{13}$");
      let visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
      let cup1 = new RegExp("^62[0-9]{14}[0-9]*$");
      let cup2 = new RegExp("^81[0-9]{14}[0-9]*$");

      let mastercard = new RegExp("^5[1-5][0-9]{14}$");
      let mastercard2 = new RegExp("^2[2-7][0-9]{14}$");

      let disco1 = new RegExp("^6011[0-9]{12}[0-9]*$");
      let disco2 = new RegExp("^62[24568][0-9]{13}[0-9]*$");
      let disco3 = new RegExp("^6[45][0-9]{14}[0-9]*$");

      let diners = new RegExp("^3[0689][0-9]{12}[0-9]*$");
      let jcb = new RegExp("^35[0-9]{14}[0-9]*$");

      if (visa.test(cc)) {
        return "visa";
      }
      if (amex.test(cc)) {
        return "amex";
      }
      if (mastercard.test(cc) || mastercard2.test(cc)) {
        return "mastercard";
      }
      if (disco1.test(cc) || disco2.test(cc) || disco3.test(cc)) {
        return "discover";
      }
      if (diners.test(cc)) {
        return "diners";
      }
      if (jcb.test(cc)) {
        return "jcb";
      }
      if (cup1.test(cc) || cup2.test(cc)) {
        return "union";
      }
      return undefined;
    },
    handleInputExpiry(event) {
      let input = event.target.value;
      input = input.replace(/\D/g, "");
      if (input.length > 2) {
        input = input.slice(0, 2) + "/" + input.slice(2);
      }
      this.cardInfo.expiry = input;
    },
    pay(paymentMethod){
      if(!paymentMethod.creditCard){
        this.run('submit',  paymentMethod.url?paymentMethod.url:this.run('get', 'paymentUrl'), {paymentMethod: paymentMethod.code});
        return;
      }
      this.loading++;
      this.run(
        "fetch",
        "index.php?option=com_cruise&task="+(this.run('get', 'config.task', "booking"))+".payment",
        {
          paymentMethod: paymentMethod.code,
          cardInfo: this.cardInfo
        }
      );
      this.loading--;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
